import React from 'react';
import { motion } from 'framer-motion';
import LuxuryButton from '../ui/LuxuryButton';
import {cardFloat} from "../animations/animations";
import {
    FaTruck,
    FaShoppingBag,
    FaHeadset
} from 'react-icons/fa';



const NextSteps = ({ orderId }) => {
    const nextSteps = [
        {
            title: 'Track Your Order',
            description: 'Monitor delivery progress in real-time',
            icon: FaTruck,
            action: () => console.log('Track order', orderId),
            variant: 'primary'
        },
        {
            title: 'Continue Shopping',
            description: 'Explore more premium products',
            icon: FaShoppingBag,
            action: () => window.location.href = '/shop',
            variant: 'outline'
        },
        {
            title: 'Contact Support',
            description: 'Our beauty advisors are here to help',
            icon: FaHeadset,
            action: () => console.log('Contact support'),
            variant: 'outline'
        }
    ];

    return (
        <motion.div
            variants={cardFloat}
            className="space-y-8"
        >
            {/* Next Steps */}
            <div>
                <h3 className="font-heading text-2xl font-medium text-charcoal mb-6">
                    What's Next?
                </h3>
                <div className="grid md:grid-cols-3 gap-4">
                    {nextSteps.map((step, index) => (
                        <motion.div
                            key={step.title}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            className="text-center"
                        >
                            <LuxuryButton
                                variant={step.variant}
                                size="large"
                                onClick={step.action}
                                icon={step.icon}
                                className="w-full h-full min-h-[140px] flex flex-col items-center justify-center gap-3 p-6"
                            >
                                <step.icon className="w-6 h-6" />
                                <div>
                                    <div className="font-medium text-charcoal mb-1">{step.title}</div>
                                    <div className="text-sm text-charcoal/50">{step.description}</div>
                                </div>
                            </LuxuryButton>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/*/!* Community & Social *!/*/}
            {/*<div className="grid md:grid-cols-2 gap-6">*/}
            {/*    /!* Newsletter *!/*/}
            {/*    <div className="p-6 rounded-2xl bg-gradient-to-br from-champagne/5 to-transparent">*/}
            {/*        <div className="flex items-center gap-3 mb-4">*/}
            {/*            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-champagne/20 to-sage/20 flex items-center justify-center">*/}
            {/*                <FaEnvelope className="w-5 h-5 text-champagne" />*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <h4 className="font-medium text-charcoal">Stay Inspired</h4>*/}
            {/*                <p className="text-sm text-charcoal/50">Join our beauty community</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="flex gap-2">*/}
            {/*            <input*/}
            {/*                type="email"*/}
            {/*                placeholder="Your email address"*/}
            {/*                className="flex-1 px-4 py-3 rounded-xl border border-nude bg-white focus:outline-none focus:border-champagne"*/}
            {/*            />*/}
            {/*            <LuxuryButton variant="primary" size="small">*/}
            {/*                Join*/}
            {/*            </LuxuryButton>*/}
            {/*        </div>*/}
            {/*        <p className="text-xs text-charcoal/40 mt-3">*/}
            {/*            Receive beauty tips, exclusive offers, and ritual inspiration*/}
            {/*        </p>*/}
            {/*    </div>*/}

            {/*    /!* Social & Referral *!/*/}
            {/*    <div className="p-6 rounded-2xl bg-gradient-to-br from-sage/5 to-transparent">*/}
            {/*        <div className="flex items-center gap-3 mb-4">*/}
            {/*            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-sage/20 to-champagne/20 flex items-center justify-center">*/}
            {/*                <FaGift className="w-5 h-5 text-sage" />*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <h4 className="font-medium text-charcoal">Share the Ritual</h4>*/}
            {/*                <p className="text-sm text-charcoal/50">Earn rewards with friends</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="space-y-3">*/}
            {/*            <div className="flex items-center gap-2">*/}
            {/*                <button className="flex-1 px-4 py-3 rounded-xl border border-nude bg-white hover:border-champagne transition-colors text-sm text-charcoal/70">*/}
            {/*                    Copy referral link*/}
            {/*                </button>*/}
            {/*                <LuxuryButton variant="outline" size="small" icon={FaInstagram}>*/}
            {/*                    Share*/}
            {/*                </LuxuryButton>*/}
            {/*            </div>*/}
            {/*            <p className="text-xs text-charcoal/40">*/}
            {/*                Give $20, get $20 when friends make their first purchase*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Additional Support */}
            <div className="p-6 rounded-2xl bg-gradient-to-r from-champagne/5 to-sage/5">
                <h4 className="font-medium text-charcoal mb-4">Need help with your order?</h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <button className="text-sm text-charcoal/60 hover:text-champagne transition-colors p-3 rounded-lg hover:bg-white">
                        Return Policy
                    </button>
                    <button className="text-sm text-charcoal/60 hover:text-champagne transition-colors p-3 rounded-lg hover:bg-white">
                        Shipping Info
                    </button>
                    <button className="text-sm text-charcoal/60 hover:text-champagne transition-colors p-3 rounded-lg hover:bg-white">
                        FAQ
                    </button>
                    <button className="text-sm text-charcoal/60 hover:text-champagne transition-colors p-3 rounded-lg hover:bg-white">
                        Live Chat
                    </button>
                </div>
            </div>
        </motion.div>
    );
};

export default NextSteps;